<div class="chat-container">
  @for (message of data.messageHistory; track message) {
    <div
      [ngClass]="{
        agent: message.role === 'agent' || message.role === 'assistant',
        user: message.role === 'user',
      }"
      class="chat-message"
    >
      <span class="content">{{
        message.content.message ?? message.content.text
      }}</span>
    </div>
  }
</div>
